import clsx from 'clsx';
import { FC } from 'react';
import { overrideTailwindClasses } from 'tailwind-override';

import { StyledLink } from 'components/atoms/StyledLink';
import { ContentNavigationMultiple } from 'types/contentful/Items/ContentNavigationItem';
import { SimpleCard } from 'components/atoms/SimpleCard';

interface Props {
  className?: string;
  content: ContentNavigationMultiple;
}

export const ContentNavigationCardMultiple: FC<Props> = ({
  className,
  content,
}) => (
  <SimpleCard
    color="black"
    className={overrideTailwindClasses(clsx('pt-8', className))}
  >
    <h3 className="mb-5 h5">{content.title}</h3>
    <ul>
      {content.links.map((link) => (
        <li key={link.href + link.text} className="mb-2">
          <StyledLink link={link} />
        </li>
      ))}
    </ul>
  </SimpleCard>
);
